<template>
	<div class="record-cls">
		<section class="audio-cls">
			<audio :src="auditFilePath" class="audio-cls" controls></audio>
		</section>
	</div>
</template>

<script>
export default {
	name: 'CommunicateRecord',
	props: ['auditFilePath'],
}
</script>

<style lang="scss" scoped>
.record-cls {
	width: 100%;
	background: #F9FCFF;
	border-radius: 0px 0px 3px 0px;
	border: 1px solid #DEDFDF;
	padding: 13px;
	box-sizing: border-box;

	& > .audio-cls > audio {
		width: 100%;
		height: 35px;
		border-radius: 35px;
		border: 1px solid #DEDFDF;
	}

	& > .im-cls {
		width: 100%;
		height: 320px;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
</style>